<template lang="pug">
  v-container
    PurchaseFail(v-if="transactionResult.paymentStatus === 'REJECTED'" :transactionResult="transactionResult" :transactionId="transactionId")
    PurchaseSuccessful(v-if="transactionResult.paymentStatus === 'AUTHORIZED'" :transactionResult="transactionResult")
    PurchaseAborted(v-if="transactionResult.paymentStatus === 'ABORTED'" :transactionResult="transactionResult" :transactionId="transactionId")
</template>

<script>
import appisTransbank from '../utils/axiosInstances'
import brand from '../utils/brand'
import PurchaseFail from '../components/PurchaseFail/PurchaseFail'
import PurchaseSuccessful from '../components/PurchaseSuccessful/PurchaseSuccessful'
import PurchaseAborted from '../components/PurchaseAborted/PurchaseAborted'
export default {
  name: 'Home',
  components: {
    PurchaseFail,
    PurchaseSuccessful,
    PurchaseAborted
  },
  data () {
    return {
      transactionResult: {
        paymentStatus: null,
        buyOrder: null,
        amount: null,
        currency: 'CLP',
        authorizationCode: null,
        paymentType: null,
        transactionDate: null,
        sharesAmount: null,
        sharesNumber: null,
        cardNumber: null,
        iteamsDescription: null,
        responseCode: null,
        courseName: null,
        initialAmount: null,
        userName: null,
        userLastname: null,
        userRut: null,
        discount: null,
        discountMount: null,
        total: null,
        enterpriseName: null,
        enterpriseRut: null,
        enterpriseAddress: null,
        enterpriseBusinessActivity: null,
        registrationType: null
      },
      transactionId: this.$route.query.transactionId
    }
  },
  methods: {
    async getPaymentData (id) {
      try {
        const response = await appisTransbank.get('/transaction/' + id)
        this.transactionResult.courseName = response.data.course.title
        this.transactionResult.initialAmount = response.data.paymentDetail.realPrice
        this.transactionResult.userName = response.data.user.name
        this.transactionResult.userLastname = response.data.user.lastName
        this.transactionResult.userRut = response.data.user.rut
        this.transactionResult.paymentStatus = response.data.status
        this.transactionResult.discount = response.data.paymentDetail.discountRate
        this.transactionResult.total = response.data.paymentDetail.total
        this.transactionResult.discountMount = response.data.paymentDetail.discount
        this.checkPaymentStatus(response.data.status)
        this.transactionResult.buyOrder = response.data.detailOutput[0].buyOrder
        this.transactionResult.amount = response.data.detailOutput[0].amount
        this.transactionResult.authorizationCode = response.data.detailOutput[0].authorizationCode
        this.transactionResult.paymentType = response.data.detailOutput[0].paymentTypeCode
        this.transactionResult.transactionDate = response.data.transactionDate
        this.transactionResult.sharesAmount = response.data.detailOutput[0].sharesAmount
        this.transactionResult.sharesNumber = response.data.detailOutput[0].sharesNumber
        this.transactionResult.cardNumber = response.data.cardDetail.cardNumber
        this.transactionResult.responseCode = response.data.detailOutput[0].responseCode
        this.transactionResult.enterpriseName = response.data.enterprise.enterpriseName
        this.transactionResult.enterpriseRut = response.data.enterprise.enterpriseRut
        this.transactionResult.enterpriseAddress = response.data.enterprise.enterpriseAddress
        this.transactionResult.enterpriseBusinessActivity = response.data.enterprise.enterpriseBusinessActivity
        this.transactionResult.registrationType = response.data.registrationType
      } catch (error) {
      }
    },
    checkPaymentStatus (status) {
      if (status === 'RETRIED') {
        window.location.href = brand.homeUrl
      }
    }
  },
  async mounted () {
    await this.getPaymentData(this.transactionId)
  }
}
</script>
